import { useMemo } from 'react';
import { SessionDto } from '@families-link/shared';
import { prepareSession } from '../utils/session.utils';

export const usePrepareSessionsData = ({
	currentSession,
	sessionsList,
}: {
	currentSession?: SessionDto;
	sessionsList?: SessionDto[];
}) => {
	const preparedCurrentSession = useMemo(() => {
		if (!currentSession) return undefined;

		const session = prepareSession(currentSession);

		return session;
	}, [currentSession]);

	const preparedSessionsList = useMemo(
		() => (sessionsList?.filter((session) => session._id !== currentSession?._id) ?? []).map(prepareSession),
		[currentSession?._id, sessionsList]
	);

	return {
		currentSession: preparedCurrentSession,
		sessionsList: preparedSessionsList,
	};
};
